import Nullstack from 'nullstack';
export default function IconAntennaBars2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-antenna-bars-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "6",
    y1: "18",
    x2: "6",
    y2: "15"
  }), "   ", Nullstack.element("line", {
    x1: "10",
    y1: "18",
    x2: "10",
    y2: "18.01"
  }), "   ", Nullstack.element("line", {
    x1: "14",
    y1: "18",
    x2: "14",
    y2: "18.01"
  }), "   ", Nullstack.element("line", {
    x1: "18",
    y1: "18",
    x2: "18",
    y2: "18.01"
  }), " ");
}